import React, { useCallback } from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import * as identify from "utils/treeUtils";
import { EllipsisWithTooltip } from "components/EllipsisWithTooltipText";
import { ConfigurationItem } from "./ConfigurationItem";
import { Icon } from "../Icon/Icon";

import styles from "./SummaryListItem.module.scss";
import type { Node } from "interfaces/schemas";
import type { NodeApi } from "@hogartrabe/react-arborist-vrh";

interface SummaryListItemProps {
  node: NodeApi<Node>;
  toggleNode: (id: string) => void;
  style?: React.CSSProperties;
}

const SummaryListItemComponent = ({
  node,
  toggleNode,
  style,
}: SummaryListItemProps) => {
  const { data } = node;
  const { id } = data;
  let folderName = "";
  if (identify.isAnyFolder(data)) {
    ({ folderName } = data);
  }

  const handleToggleDetails = useCallback(() => {
    node.toggle();
    toggleNode(id);
  }, [id, node, toggleNode]);

  return (
    <div className="mw-100">
      {node ? (
        <>
          {!identify.isAnyProduct(data) ? (
            <div
              className={cx(
                "d-flex  justify-content-between align-items-center border-bottom ms-2",
                styles.item,
              )}
              style={style}
            >
              <div className="d-flex align-items-center mw-100">
                {node.children && (
                  <>
                    {node.children.length > 0 ? (
                      <>
                        <Icon
                          onClick={handleToggleDetails}
                          iconName={
                            node.isOpen
                              ? "chevron-down-regular"
                              : "chevron-right-regular"
                          }
                          className="icon-16 ms-1 me-3 cursor-pointer"
                        />
                      </>
                    ) : (
                      <div className={cx("ms-1", styles.noNodes)} />
                    )}
                  </>
                )}

                <div className="fw-bolder fs-md mw-95">
                  <EllipsisWithTooltip text={folderName || ""} />
                </div>
              </div>
            </div>
          ) : (
            <ConfigurationItem key={id} conf={data} style={style} />
          )}
        </>
      ) : (
        <div
          className={cx(
            "d-flex justify-content-between align-items-center border-bottom fw-bolder ps-2_5",
            styles.item,
          )}
        >
          <div className="ms-5 fs-md mw-95">{folderName}</div>
        </div>
      )}
    </div>
  );
};

export const SummaryListItem = Scrivito.connect(SummaryListItemComponent);
